<Chip
    selectable={false}
    add={entry.categories[0].colorCode !== null ? entry.categories[0].colorCode : 'bg-gray-300'}
    remove="bg-gray-300"
>
    { entry.categories[0].title }
</Chip>

<script lang="ts">
    import {Chip} from 'smelte';

    export let entry: any;
</script>